import useFormatter from "@/hooks/use-formatter.hook.ts";
import { useOpenEsignRequest } from "@/pages/esign/use-open-esign-request.hook.ts";
import { ApiEsignRequest, EsignSignatureType } from "@/types/esign.types.ts";
import { Avatar, Button, DotSeparator, FontAwesomeIcon, ListItem, Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface EsignRequestRowProps {
  esignRequest: ApiEsignRequest;
}

export function EsignRequestRow({ esignRequest }: EsignRequestRowProps) {
  const { t } = useTranslation();
  const { renderDate } = useFormatter();
  const openEsignRequest = useOpenEsignRequest();

  const isAcknowledge = esignRequest.signature_type === EsignSignatureType.acknowledge;

  return (
    <ListItem
      title={
        isAcknowledge
          ? t("core:esign_request_awaiting_acknowledgment")
          : t("core:esign_request_awaiting_signature")
      }
      icon={
        <Avatar
          icon={
            <FontAwesomeIcon
              icon={isAcknowledge ? "fa-light fa-file-check" : "fa-light fa-file-signature"}
              className={"text-[22px]"}
            />
          }
        />
      }
      forceShowAvatar={true}
      captionSlot={
        <DotSeparator>
          <Text className={"text-secondary"}>{esignRequest.document_title}</Text>
          {esignRequest.date_due && (
            <Text className={"text-secondary"}>{renderDate(esignRequest.date_due)}</Text>
          )}
        </DotSeparator>
      }
      valueSlot={
        <Button
          rightIcon={<FontAwesomeIcon icon="fa-light fa-chevron-right" />}
          variant="plain"
          onClick={() => openEsignRequest(esignRequest)}
        >
          {isAcknowledge ? t("core:esign_read_and_agree") : t("core:esign_sign")}
        </Button>
      }
      behavior={"card"}
    />
  );
}
